import React from 'react'
import styled from 'styled-components'
import { zoning_indice_sources } from '@popety-io/types'
import { EditableMetricInput } from './EditableMetricInput'
import { MetricSourceBadge } from '../../../atoms/MetricSourceBadge'

const MinMaxWrapper = styled.div`
  display: flex;
  align-items: flex-end;
  gap: ${({ theme }) => theme.spacing.xsmall};
`

const InputGroup = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
`

const InputLabel = styled.span<{ $isMin?: boolean }>`
  font-size: 8px;
  font-weight: 600;
  color: ${({ $isMin }) => ($isMin ? '#3b82f6' : 'inherit')};
  margin-bottom: 2px;
  text-transform: uppercase;
`

const Separator = styled.span`
  color: ${({ theme }) => theme.colors.text.tertiary};
  font-size: 13px;
  padding-bottom: 6px;
`

const BadgeWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 2px;
  min-height: 16px;
`

interface EditableMinMaxInputProps {
  metricKey: string
  minValue?: number
  maxValue?: number
  isMinOverridden: boolean
  isMaxOverridden: boolean
  isMinPending: boolean
  isMaxPending: boolean
  minSource?: zoning_indice_sources
  maxSource?: zoning_indice_sources
  onValueChange: (metricKey: string, value: number) => void
  onValueClear: (metricKey: string) => void
}

export const EditableMinMaxInput: React.FC<EditableMinMaxInputProps> = ({
  metricKey,
  minValue,
  maxValue,
  isMinOverridden,
  isMaxOverridden,
  isMinPending,
  isMaxPending,
  minSource,
  maxSource,
  onValueChange,
  onValueClear,
}) => {
  return (
    <MinMaxWrapper>
      <InputGroup>
        <InputLabel $isMin>Min</InputLabel>
        <EditableMetricInput
          metricKey={metricKey}
          suffix="_min"
          value={minValue}
          isOverridden={isMinOverridden}
          isPending={isMinPending}
          onValueChange={onValueChange}
          onValueClear={onValueClear}
        />
        <BadgeWrapper>
          {minSource && <MetricSourceBadge source={minSource} />}
        </BadgeWrapper>
      </InputGroup>
      <Separator>/</Separator>
      <InputGroup>
        <InputLabel>Max</InputLabel>
        <EditableMetricInput
          metricKey={metricKey}
          suffix="_max"
          value={maxValue}
          isOverridden={isMaxOverridden}
          isPending={isMaxPending}
          onValueChange={onValueChange}
          onValueClear={onValueClear}
        />
        <BadgeWrapper>
          {maxSource && <MetricSourceBadge source={maxSource} />}
        </BadgeWrapper>
      </InputGroup>
    </MinMaxWrapper>
  )
}
